import s from "./NormalisationProgressPanel.module.css";

export interface NormalisationProgressPanelProps {
  /** User-facing import source type from the catalogue (CN-02). */
  importSourceType: string;
  fileName: string;
}

/** CN-05 — in-flight normalisation (wireframe: Run progress card). */
export function NormalisationProgressPanel({
  importSourceType,
  fileName,
}: NormalisationProgressPanelProps) {
  return (
    <section
      className={s.section}
      aria-labelledby="normalisation-progress-heading"
      role="status"
      aria-live="polite"
    >
      <h2 id="normalisation-progress-heading" className={s.heading}>
        Normalise payslip PDF
      </h2>
      <p className={s.processingLine}>
        <span className={s.spinner} aria-hidden="true" />
        Processing {fileName}
      </p>

      <div className={s.runProgressCard}>
        <h4 className={s.runProgressTitle}>Run progress</h4>
        <table className={s.progressTable}>
          <caption className={s.caption}>
            Normalisation run metadata while the payslip PDF is processed
          </caption>
          <tbody>
            <tr>
              <th scope="row">Import source type</th>
              <td>{importSourceType}</td>
            </tr>
            <tr>
              <th scope="row">Detail rows</th>
              <td>
                Extracting Gross Pay · Gross Taxable · PAYE · Net Pay · KS EE ·
                KS ER Gross/Net · KS ER ESCT · Student Loan
              </td>
            </tr>
            <tr>
              <th scope="row">Excluded rows</th>
              <td>Employee name · IRD number · Bank account</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}
